"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultDateFormatter = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var dateValueParser_1 = require("./dateValueParser");
/**
 * Creates a default date formatting function.
 * @public
 */
exports.createDefaultDateFormatter = function (dateFormat) {
    if (dateFormat === void 0) { dateFormat = dateValueParser_1.DEFAULT_DATE_FORMAT; }
    return function (value, targetDateFormat) {
        if (targetDateFormat === void 0) { targetDateFormat = dateFormat; }
        if (!dateValueParser_1.dateFormats.includes(targetDateFormat)) {
            throw new sdk_backend_spi_1.UnexpectedError("Unsupported date format \"" + targetDateFormat + "\". Supported date formats are " + dateValueParser_1.dateFormats);
        }
        return format_1.default(value, targetDateFormat);
    };
};
//# sourceMappingURL=defaultDateFormatter.js.map